// App config
const appConfig = process.env.CONFIG;
/**
 * This is the definition of the entire state tree the Redux store is going to use.
 */
export const state = {
  upload: {
    errorCode: '',
    imageUrl: '',
    imageDimensions: {},
    experimentData: '{}',
  },
  crop: {
    cropEndpointCalled: false,
    cropData: [],
    initialRegionData: [],
    md5: '',
    isAnyRegionDeleted: false,
    annotationIndex: 0,
    cropAreaSize: {},
    drawingMode: false,
    errorCode: '',
    loading: false,
    croppedImageUrl: '',
    verticalCropSelected: false,
    cropToolbar: {
      showNextButtonEnabledTooltip: false,
    },
    rotationMode: false,
    rotationAmount: 0,
  },
  result: {
    resultData: {},
    fontPreviewInputText: '',
    fontPreviewSliderValue: appConfig.fontPreviewToolbar.defaultSliderValue,
    errorCode: '',
    isNewResultRequestNeeded: true,
    resultsPageNumber: 1,
  },
};



// WEBPACK FOOTER //
// ./src/store/state.js